import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;
//分页查询地图信息
export const GetMapLocationPage = (data) => {
  return axios.post(`${base}/api/MapLocation/GetMapLocationPage`, data);
};

//添加
export const AddMapLocation = (data) => {
  return axios.post(`${base}/api/MapLocation/AddMapLocation`, data);
};

// 修改
export const PutMaplocation = (data) => {
  return axios.post(`${base}/api/MapLocation/PutMaplocation`, data);
};

// 详情
export const GetMaplocation = (params) => {
  return axios.get(`${base}/api/MapLocation/GetMaplocation`, {
    params: params,
  });
};

//删除
export const DeleteMapLocation = (params) => {
  return axios.delete(`${base}/api/MapLocation/DeleteMapLocation`, {
    params: params,
  });
};
